import { getAllLocales, getLocale, setLocale } from '@@/exports';
import { GlobalOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import type { MenuProps } from 'antd';
import { Dropdown, Space, Typography } from 'antd';
import React from 'react';

export type SiderTheme = 'light' | 'dark';

const localeLabelMap: Record<string, string> = {
  'en-US': 'English',
  'zh-CN': '简体中文',
  'zh-TW': '繁體中文',
};

export const SelectLang: React.FC = () => {
  const currentLocale = getLocale();
  const localeItems: MenuProps['items'] = getAllLocales().map((locale) => ({
    key: locale,
    label: localeLabelMap[locale] || locale,
  }));

  return (
    <Dropdown
      menu={{
        items: localeItems,
        onClick: ({ key }) => {
          if (key !== currentLocale) {
            setLocale(String(key), false);
          }
        },
        selectedKeys: [currentLocale],
      }}
      placement="bottomRight"
      trigger={['click']}
    >
      <span style={{ display: 'inline-flex' }}>
        <Space
          size={4}
          style={{
            cursor: 'pointer',
            padding: 4,
            userSelect: 'none',
          }}
        >
          <GlobalOutlined />
          <Typography.Text>
            {localeLabelMap[currentLocale] || currentLocale}
          </Typography.Text>
        </Space>
      </span>
    </Dropdown>
  );
};

export const Question: React.FC = () => {
  return (
    <a
      href="https://pro.ant.design/docs/getting-started"
      target="_blank"
      rel="noreferrer"
      style={{
        display: 'inline-flex',
        padding: '4px',
        fontSize: '18px',
        color: 'inherit',
      }}
    >
      <QuestionCircleOutlined />
    </a>
  );
};
